import * as type from "../types";

export const setFilterPeriod = (filterPeriod) => ({
  type: type.SET_FILTER_PERIOD,
  payload: filterPeriod,
});

export const setInvoiceFilterPeriod = (filterPeriod) => ({
  type: type.SET_INVOICE_FILTER_PERIOD,
  payload: filterPeriod,
});

export const getReconciliationInfoRequest = (term) => ({
  type: type.GET_RECONCILIATION_INFO_REQUEST,
  payload: term,
});

export const getReconciliationInfoSucceeded = (status) => ({
  type: type.GET_RECONCILIATION_INFO_SUCCEEDED,
  payload: status,
});

export const getReconciliationInfoFailed = () => ({
  type: type.GET_RECONCILIATION_INFO_FAILED,
});

export const getReconciliationListRequest = (reqParams) => ({
  type: type.GET_RECONCILIATION_LIST_REQUEST,
  payload: reqParams,
});

export const getReconciliationListSucceeded = (payload) => ({
  type: type.GET_RECONCILIATION_LIST_SUCCEEDED,
  payload: payload,
});

export const getReconciliationListFailed = () => ({
  type: type.GET_RECONCILIATION_LIST_FAILED,
});

export const setSelectedReconciliationId = (selectedReconciliationId) => ({
  type: type.SET_SELECTED_RECONCILIATION_ID,
  payload: selectedReconciliationId,
});

export const getSelectedReconciliationDetailsRequest = (reqParams) => ({
  type: type.GET_SELECTED_RECONCILIATION_DETAILS_REQUEST,
  payload: reqParams,
});

export const getSelectedReconciliationDetailsSucceeded = (details) => ({
  type: type.GET_SELECTED_RECONCILIATION_DETAILS_SUCCEEDED,
  payload: details,
});

export const getSelectedReconciliationDetailsFailed = () => ({
  type: type.GET_SELECTED_RECONCILIATION_DETAILS_FAILED,
});

export const getSelectedReconciliationItemDetailsRequest = (
  organizationId,
  reqParams
) => ({
  type: type.GET_SELECTED_RECONCILIATION_ITEM_DETAILS_REQUEST,
  payload: {
    organizationId,
    reqParams,
  },
});

export const getSelectedReconciliationItemDetailsSucceeded = (itemDetails) => ({
  type: type.GET_SELECTED_RECONCILIATION_ITEM_DETAILS_SUCCEEDED,
  payload: itemDetails,
});

export const getSelectedReconciliationItemDetailsFailed = () => ({
  type: type.GET_SELECTED_RECONCILIATION_ITEM_DETAILS_FAILED,
});

export const removeReconciliationItemDetails = (itemType) => ({
  type: type.REMOVE_RECONCILIATION_ITEM_DETAILS,
  payload: itemType,
});

export const clearSelectedReconciliation = () => ({
  type: type.CLEAR_SELECTED_RECONCILIATION,
});

export const clearItemDetails = () => ({
  type: type.CLEAR_ITEM_DETAILS,
});

export const clearInfo = () => ({
  type: type.CLEAR_INFO,
});
